export default {"src":"/_next/static/media/sort-icon.964e89be.svg","height":16,"width":16};